import React from 'react';
export function MaterialSection() {
  return <section id="material" className="py-20 bg-white" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="text-center mb-16" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-79">
            Le matériau du futur
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-80">
            Nos Blocs de Terre Compactée Dynamique (BTCD) révolutionnent la
            construction durable
          </p>
        </div>
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-81">
          <div className="mb-10 lg:mb-0" data-id="element-82">
            <div className="relative rounded-xl overflow-hidden shadow-xl" data-id="element-83">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uH7R7TxzoFZ1kKdNgN2g4d/Diapositive4.jpg" alt="Stockage de Blocs de Terre Compactée Dynamique dans notre usine" className="w-full h-auto" data-id="element-84" />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#8d6e4b]/30 to-transparent" data-id="element-85"></div>
              <div className="absolute bottom-4 left-4 bg-white bg-opacity-90 rounded-lg p-3 shadow-md" data-id="element-86">
                <p className="font-bold text-[#8d6e4b]" data-id="element-87">BTCD</p>
                <p className="text-gray-700 text-sm" data-id="element-88">
                  Blocs de Terre Compactée Dynamique
                </p>
              </div>
            </div>
            <div className="mt-8 bg-[#f5f1e8] rounded-lg p-6 shadow-inner" data-id="element-89">
              <h3 className="font-bold text-xl text-gray-900 mb-4" data-id="element-90">
                BTCD vs Béton traditionnel
              </h3>
              <div className="space-y-3" data-id="element-91">
                <div className="flex items-center" data-id="element-92">
                  <div className="w-3 h-3 rounded-full bg-[#b8a077] mr-3" data-id="element-93"></div>
                  <p className="text-gray-700" data-id="element-94">
                    Matériau 100% recyclable et réutilisable
                  </p>
                </div>
                <div className="flex items-center" data-id="element-95">
                  <div className="w-3 h-3 rounded-full bg-[#b8a077] mr-3" data-id="element-96"></div>
                  <p className="text-gray-700" data-id="element-97">Inertie thermique supérieure</p>
                </div>
                <div className="flex items-center" data-id="element-98">
                  <div className="w-3 h-3 rounded-full bg-[#b8a077] mr-3" data-id="element-99"></div>
                  <p className="text-gray-700" data-id="element-100">
                    Régulation naturelle de l'humidité
                  </p>
                </div>
                <div className="flex items-center" data-id="element-101">
                  <div className="w-3 h-3 rounded-full bg-[#b8a077] mr-3" data-id="element-102"></div>
                  <p className="text-gray-700" data-id="element-103">
                    Résistance mécanique comparable au béton
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-8" data-id="element-104">
            <div className="bg-gradient-to-br from-[#e8e0cc] to-[#d6c8a9] rounded-xl p-8 shadow-lg" data-id="element-105">
              <div className="text-4xl md:text-5xl font-bold text-[#8d6e4b] mb-2" data-id="element-106">
                96%
              </div>
              <p className="text-lg text-gray-700" data-id="element-107">
                d'émissions de CO₂ évitées par rapport au béton traditionnel
              </p>
            </div>
            <div className="bg-gradient-to-br from-[#e8e0cc] to-[#d6c8a9] rounded-xl p-8 shadow-lg" data-id="element-108">
              <div className="text-4xl md:text-5xl font-bold text-[#8d6e4b] mb-2" data-id="element-109">
                80 000 t
              </div>
              <p className="text-lg text-gray-700" data-id="element-110">
                de béton remplacées grâce à notre production annuelle
              </p>
            </div>
            <div className="bg-gradient-to-br from-[#e8e0cc] to-[#d6c8a9] rounded-xl p-8 shadow-lg" data-id="element-111">
              <div className="text-4xl md:text-5xl font-bold text-[#8d6e4b] mb-2" data-id="element-112">
                23 200 t
              </div>
              <p className="text-lg text-gray-700" data-id="element-113">
                de CO₂ évitées par an, équivalent à 2 millions d'arbres sur 5
                ans
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}